import { useState } from 'react';
import { AnchorBar, AnchorBarList, AnchorBarListItem, BoundedContent, Divider } from '@vp/swan';
import styled from 'styled-components';
import { NavItem } from '../pageData/tierServiceDetailPage';

const LeftAlignedAnchorBarList = styled(AnchorBarList)`
    padding-left: 0;

    .swan-anchor-bar-list-item:first-child {
        margin-left: 0;
    }
`;
interface TierNavBarProps {
    navItems: NavItem[];
}

export function TierNavBar({ navItems }: TierNavBarProps) {
    const [activeAnchor, setActiveAnchor] = useState();

    return (
        <BoundedContent>
            <AnchorBar bgc="standard" onActiveAnchorChanged={setActiveAnchor}>
                <LeftAlignedAnchorBarList>
                    {navItems.map((item) => (
                        <AnchorBarListItem key={item.href}>
                            <a
                                href={item.href}
                                aria-current={activeAnchor === item.href ? 'true' : undefined}
                            >
                                {item.label}
                            </a>
                        </AnchorBarListItem>
                    ))}
                </LeftAlignedAnchorBarList>
            </AnchorBar>
            <Divider />
        </BoundedContent>
    );
}
